import PriRouter from "..";

const routes = [
    { name: "ProgettoRiabilitativoIndividuale", path: "/rsapaziente/pri", component: PriRouter.ProgettoRiabilitativoIndividualeListPage, meta: { title: " Progetti Riabilitativi " } },
];

export default routes;
